import {useState} from "react";
import {Button, Divider, Grid, Stack, Typography} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOffRounded";
import {OAuthCredentials} from "../../types/domain/oauthCredentials";
import {ActionButton} from "../base/ActionButton";
import {useTranslation} from "react-i18next";

export interface Props {
    credentials: OAuthCredentials | undefined;
    isLoading: boolean;
    onRotateCredentials: () => void;
}

export const ApiCredentialsCard: React.FC<Props> = ({credentials, isLoading, onRotateCredentials}) => {
    const {t} = useTranslation();

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Stack direction="column">
                    <Typography textTransform="uppercase" sx={{color: "#737990"}} fontSize={14}>
                        {t("users.api_credentials.api_key")}
                    </Typography>
                    <Divider sx={{marginBottom: "0.6rem"}} />
                    <SecretValue value={credentials?.oauthClientId} />
                </Stack>
            </Grid>
            <Grid item xs={12}>
                <Stack direction="column">
                    <Typography textTransform="uppercase" sx={{color: "#737990"}} fontSize={14}>
                        {t("users.api_credentials.api_password")}
                    </Typography>
                    <Divider sx={{marginBottom: "0.6rem"}} />
                    <SecretValue value={credentials?.oauthClientSecret} />
                </Stack>
            </Grid>
            <Grid item xs={12}>
                <ActionButton icon="loop" color="secondary" onClick={onRotateCredentials} disabled={isLoading}>
                    {t("users.api_credentials.regenerate")}
                </ActionButton>
            </Grid>
        </Grid>
    );
};

const SecretValue: React.FC<{value?: string}> = ({value}) => {
    const {t} = useTranslation();
    const [showSecret, setShowSecret] = useState<boolean>(false);

    return (
        <Stack direction="row" spacing={2} alignItems="center">
            <Typography fontSize={14}>{showSecret ? value : SECRET_ASTERISKS_STR}</Typography>
            <Button onClick={() => setShowSecret(!showSecret)}>
                <Stack direction="row" spacing={1} alignItems="center">
                    {showSecret ? (
                        <VisibilityOffIcon fontSize="small" color="primary" />
                    ) : (
                        <VisibilityIcon fontSize="small" color="primary" />
                    )}
                    <Typography textTransform="uppercase" fontSize={14} color="primary">
                        {showSecret
                            ? t("users.api_credentials.hide_credentials")
                            : t("users.api_credentials.show_credentials")}
                    </Typography>
                </Stack>
            </Button>
        </Stack>
    );
};

const SECRET_ASTERISKS_STR = "*********************";
